module.exports = __webpack_public_path__ + "img/social-share.60ca7811.png";